export default {
  AIR_FORCE: 'air force',
  ARMY: 'army',
  COAST_GUARD: 'coast guard',
  MARINE_CORPS: 'marine corps',
  NAVY: 'navy',
  SPACE_FORCE: 'space force',
};
